<template>
  <div class="admin-user-page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索用户名" class="search" clearable />
      <el-button type="primary" @click="loadList">搜索</el-button>
      <el-button type="primary" @click="openDialog">新增管理员</el-button>
    </div>
    <el-table :data="list" stripe style="width:100%">
      <el-table-column prop="username" label="用户名" />
      <el-table-column prop="role_name" label="角色" width="120" />
      <el-table-column prop="email" label="邮箱" />
      <el-table-column prop="status" label="状态" width="80">
        <template #default="{row}">
          <el-tag :type="row.status ? 'success' : 'info'">{{ row.status ? '启用':'禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template #default="{row}">
          <el-button size="small" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" :current-page="pagination.page" :page-size="pagination.pageSize" :total="pagination.total" layout="prev, pager, next" @current-change="pageChange" />

    <el-dialog v-model="dialogVisible" title="管理员信息" width="400px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="用户名">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="form.role_id" style="width:100%">
            <el-option
              v-for="r in roleOptions"
              :key="r.id"
              :label="r.name"
              :value="r.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="form.password" placeholder="留空不修改" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="禁用" :value="0" />
            <el-option label="启用" :value="1" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import md5 from 'js-md5'
import request from '../../utils/request'

const list = ref([])
const pagination = ref({ page:1, pageSize:30, total:0 })
const keyword = ref('')
const dialogVisible = ref(false)
const loading = ref(false)
const roleOptions = ref([])
const form = ref({ id:null, username:'', email:'', role_id:null, password:'', status:1 })

const loadList = async () => {
  const params = { page: pagination.value.page, pageSize: pagination.value.pageSize, keyword: keyword.value }
  try {
    const data = await request.get('/v1/admin-user/list',{ params })
    list.value = data.list
    pagination.value.total = data.pagination.total
  } catch (e) { ElMessage.error(e.toString()) }
}

const loadRoles = async () => {
  try {
    roleOptions.value = await request.get('/v1/admin/role')
  } catch (e) {
    roleOptions.value = []
  }
}

const pageChange = (p) => { pagination.value.page=p; loadList() }

const openDialog = () => {
  form.value = { id:null, username:'', email:'', role_id:null, password:'', status:1 }
  loadRoles()
  dialogVisible.value = true
}

const edit = (row) => {
  form.value = { id:row.id, username:row.username, email:row.email, role_id:row.role_id, password:'', status:row.status }
  loadRoles()
  dialogVisible.value=true
}

const submit = async () => {
  loading.value=true
  const payload = { ...form.value }
  if (payload.password) payload.password = md5(payload.password)
  try {
    if (payload.id) await request.post('/v1/admin-user/update', payload)
    else await request.post('/v1/admin-user/create', payload)
    ElMessage.success('操作成功')
    dialogVisible.value=false
    loadList()
  } catch(e){ ElMessage.error(e.toString()) }
  finally { loading.value=false }
}

const remove = async(row)=>{
  try{ await request.post('/v1/admin-user/delete',{ id:row.id }); ElMessage.success('删除成功'); loadList() }catch(e){ ElMessage.error(e.toString()) }
}

onMounted(() => {
  loadRoles()
  loadList()
})
</script>

<style scoped>
.admin-user-page .toolbar{margin-bottom:15px;display:flex;gap:10px}
.search{width:200px}
.pager{margin-top:15px;text-align:right}
</style>
